<template>
  <div class="station-tabbed-page">
    <div class="station-tag-content">
      <slot name="tabcontent" />
    </div>
    <div class="station-tab-bar">
      <slot name="tablist" />
    </div>
  </div>
</template>

<style lang="scss" scoped>
$station-tabbar-height: 64px;

.station-tabbed-page {
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: stretch;
}
.station-tag-content {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: stretch;
}
.station-tab-bar {
  height: calc(#{$station-tabbar-height} + 2px);
  margin: 0;
  padding: 0;
  border-top: 1px solid #505050;
  background-color: #101010;
  display: flex;
  flex-direction: row;
}
</style>


<script>
import _ from 'lodash'

export default {
  name: 'StationTabbedPage',
  provide() {
    return {
      stationTabbedPage: this
    }
  },
  data() {
    return {
      registeredTabItems: [],
      registeredTabContentItems: [],
    }
  },
  methods: {
    showTab(tabItem) {
      var index = _.findIndex(this.registeredTabItems, i => i == tabItem)

      this.registeredTabItems.forEach((tab, tabIndex) => {
        tab.active = index == tabIndex
      })
      this.registeredTabContentItems.forEach((tab, tabIndex) => {
        tab.active = index == tabIndex
      })
    },
    registerTabItem(item) {
      if(!this.registeredTabItems.find(i => i === item)) {
        this.registeredTabItems.push(item)
        item.$once('hook:destroyed', () => {
          this.unregisterTabItem(item)
        })
        item.active = this.registeredTabItems.length == 1
      }
    },
    unregisterTabItem(item) {
      this.registeredTabItems = this.registeredTabItems.slice().filter(i => i !== item)
    },
    registerTabContentItem(item) {
      if(!this.registeredTabContentItems.find(i => i === item)) {
        this.registeredTabContentItems.push(item)
        item.$once('hook:destroyed', () => {
          this.unregisterTabContentItem(item)
        })
        item.active = this.registeredTabContentItems.length == 1
      }
    },
    unregisterTabContentItem(item) {
      this.registeredTabContentItems = this.registeredTabContentItems.slice().filter(i => i !== item)
    }
  }
}
</script>